import React, { Component, Fragment } from "reactn";
import { Gap10, Gap20 } from "js/react/components/Gap";
import { BlueSwitch } from "js/react/components/Switch.js";
import { app } from "js/namespaces";
import {
    BlueButton,
    Section,
    UIPane,
    UIPaneContents,
    UIPaneHeader
} from "js/react/components/UiComponents";
import { Snackbar } from "@material-ui/core";

class PreferencesPane extends Component {
    constructor() {
        super();
        this.state = {
            allowSpellChecking: !app.user.get("ignoreSpellcheck"),
            currentPane: "account",
            showResetText: false
        };
    }

    handleSpellcheckChange = () => {
        this.setState(
            { allowSpellChecking: !this.state.allowSpellChecking },
            () => {
                app.user.update({
                    ignoreSpellcheck: !this.state.allowSpellChecking
                });
                if (app.mainView.editorView && app.mainView.editorView.selectionLayer) {
                    app.mainView.editorView.selectionLayer.checkSpelling();
                }
            }
        );
    };

    handleResetDictionary = () => {
        app.dictionary.replace({
            id: app.dictionary.get("id"),
            userId: app.dictionary.get("userId")
        });
        if (app.mainView.editorView && app.mainView.editorView.selectionLayer) {
            app.mainView.editorView.selectionLayer.checkSpelling();
        }
        this.setState({ showResetText: true });
    };

    render() {
        const { showResetText } = this.state;
        return (
            <UIPane>
                <UIPaneHeader>Preferences</UIPaneHeader>
                <UIPaneContents>
                    <Section title="Spellcheck">
                        <div className="content-wrapper">
                            <div className="input-column spellcheck">
                                <BlueSwitch
                                    checked={this.state.allowSpellChecking}
                                    onChange={() =>
                                        this.handleSpellcheckChange(
                                            "allowSpellChecking"
                                        )
                                    }
                                    label="Check Spelling As You Type"
                                />
                                <Gap20 />
                                <div className="input-row">
                                    <BlueButton
                                        onClick={this.handleResetDictionary}
                                    >
                                        Reset Dictionary
                                    </BlueButton>
                                    <Snackbar
                                        open={showResetText}
                                        message="Your dictionary has been reset and ignored words will now be checked for spelling mistakes"
                                        onClose={() =>
                                            this.setState({
                                                showResetText: false
                                            })
                                        }
                                        autoHideDuration={3000}
                                    />
                                    {/*<div className={classNames({*/}
                                    {/*[`reset-text`]: true,*/}
                                    {/*[`hidden`]: !showResetText,*/}
                                    {/*[`fade-out`]: showResetText,*/}
                                    {/*})}>*/}
                                    {/*Your ignored words will now be checked for spelling mistakes.*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </Section>
                </UIPaneContents>
            </UIPane>
        );
    }
}

export default PreferencesPane;
